import { connectionData, endpoint } from 'data/apiConection.js/apiConnection';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const LoginForm = ({ hasLabel }) => {
  const navigate = useNavigate();
  
  // State
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    remember: false
  });
  const handleSubmit = async e => {
    e.preventDefault();
    toast.success(`Logging in as ${formData.email}`, { theme: 'colored' });

    try {
      const responseLogin = await connectionData(endpoint, 'users/login', 'POST', formData);
      
      if ( responseLogin ) {
        console.log(responseLogin);
        validateUser(responseLogin);
      } else {
        toast.error("Login failed. Please check your credentials.", { theme: 'colored' });
      }
    } catch (error) {
      console.error("Error during login:", error);
      toast.error("An error occurred while logging in.", { theme: 'colored' });
    }
  };
  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const validateUser = (responseLogin) => {
    localStorage.setItem('user',JSON.stringify(responseLogin));
    responseLogin.role==='father'?
      navigate('/estados-cuentas'):
      navigate('/');
      ;
  }
  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Email</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Email' : ''}
          value={formData.email}
          name="email"
          onChange={handleFieldChange}
          type="email"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Contraseña</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Contraseña' : ''}
          value={formData.password}
          name="password"
          onChange={handleFieldChange}
          type="password"
        />
      </Form.Group>

      <Row className="justify-content-between align-items-center">
        <Col xs="auto">
          <Form.Check type="checkbox" id="rememberMe" className="mb-0">
            <Form.Check.Input
              type="checkbox"
              name="remember"
              checked={formData.remember}
              onChange={e =>
                setFormData({
                  ...formData,
                  remember: e.target.checked
                })
              }
            />
            <Form.Check.Label className="mb-0 text-700">
              Recordar
            </Form.Check.Label>
          </Form.Check>
        </Col>
        {/*
        <Col xs="auto">
          <Link
            className="fs--1 mb-0"
            to={`/authentication/${layout}/forgot-password`}
          >
            Olvidaste tu Contraseña?
          </Link>
        </Col>*/}

      </Row>

      <Form.Group>
        <Button
          type="submit"
          color="primary"
          className="mt-3 w-100"
          disabled={!formData.email || !formData.password }
        >
          Ingresar
        </Button>
      </Form.Group>
    </Form>
  );
};

LoginForm.propTypes = {
  hasLabel: PropTypes.bool
};

LoginForm.defaultProps = {
  hasLabel: false
};

export default LoginForm;

